var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "delete",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.274,
    height: 16.156,
    viewBox: "0 0 11.274 16.156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23297",
    "data-name": "Group 23297",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23296",
    "data-name": "Group 23296",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11289",
    "data-name": "Path 11289",
    d: "M64,95a1.61,1.61,0,0,0,1.611,1.611h6.443A1.61,1.61,0,0,0,73.664,95V85.333H64Z",
    transform: "translate(-63.195 -81.201)",
    fill: "none",
    stroke: "#0074b0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11290",
    "data-name": "Path 11290",
    d: "M51.123.805,50.317,0H46.291l-.805.805H42.667V2.416H53.941V.805Z",
    transform: "translate(-42.667)",
    fill: "#0074b0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.27e8ad4cb7954d2a6c896a8286fb1d6e.svg";
export { ForwardRef as ReactComponent };